const headers = {
  name: "Purchase Order",
  navigate: {
    path: [
      {
        name: "Orders",
        path: "/app/purchases",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
